export enum PopoverType {
  Menu = 'menu',
  Reactions = 'reactions',
}

export type PopoverDetail = {
  messageId: string;
  popoverType: PopoverType | undefined;
};
